import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { PanelSkeleton } from '../../shared/formPanel';
import ProgramInformationPanel from './ProgramInformationPanel';
import { EditableProgram, useLicenses } from './useProgram';

// The Program Information section needs the license list as well as the program.
const ProgramInformationSection = () => {
  const program = useOutletContext<EditableProgram>();
  const licenses = useLicenses();

  if (licenses.isLoading) return <PanelSkeleton />;
  if (!licenses.data) {
    return (
      <p className="tw-m-0 tw-text-sm tw-text-spa-error" role="alert">
        Couldn’t load the licenses. Reload the page to try again.
      </p>
    );
  }

  return <ProgramInformationPanel licenses={licenses.data} program={program} />;
};

export default ProgramInformationSection;
